import { render } from "./MarketoLogoIcon.vue?vue&type=template&id=30864aae"
import script from "./MarketoLogoIcon.vue?vue&type=script&lang=js"
export * from "./MarketoLogoIcon.vue?vue&type=script&lang=js"

import "./MarketoLogoIcon.vue?vue&type=style&index=0&id=30864aae&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__